import React from "react";
import { Link } from "react-router-dom";
function Navbar() {
  return (
    <nav>
      <div className="logo">
        <img
          src="https://lh4.googleusercontent.com/-S-RbZ4Yc7sg/AAAAAAAAAAI/AAAAAAAAAAA/CXaYo2aSfVk/s36-c-k/photo.jpg"
          alt="satendra sharma"
        />
      </div>
      <Link to="/">
        <h2>&lt;CodeMind /&gt;</h2>
      </Link>
    </nav>
  );
}

export default Navbar;
